import React from 'react';
import What3WordsSearchResult from '../../What3Words/What3WordsSearchResult';
import { StyledCallPane as W3wPane } from '../sharedPaneStyles';

const W3wCallPane = ({ hasLocationsToRender, hasW3w, selectedCallerID }) => {
  const renderStandalonePane =
    (selectedCallerID && !hasLocationsToRender) || !selectedCallerID;
  return (
    <W3wPane w3w>
      <What3WordsSearchResult
        renderStandalonePane={renderStandalonePane}
        hasW3w={hasW3w}
      />
    </W3wPane>
  );
};

export default W3wCallPane;
